export default __webpack_public_path__ + "static/media/karta-mm.53ac88ce.png";